/**
 * cookie存储服务
 */
export default {
  /**
   *
   * @param {*} cookieName  cookie名
   * @param {*} cookieValue coojie值
   * @param {*} cookieDates cookie存储时长
   */
  saveCookie(cookieName, cookieValue, cookieDates, path = "") {
    var d = new Date();
    d.setDate(d.getDate() + cookieDates);
    document.cookie =
      cookieName +
      "=" +
      cookieValue +
      ";expires=" +
      d.toGMTString() +
      ";path=/" +
      encodeURIComponent(path);
  },
  /**
   * 获取cookie
   * @param {*} cookieName cookie名称
   */
  getCookie(cookieName) {
    var cookieStr = unescape(document.cookie);
    var arr = cookieStr.split("; ");
    var cookieValue = "";
    for (var i = 0; i < arr.length; i++) {
      var temp = arr[i].split("=");
      if (temp[0] == cookieName) {
        cookieValue = temp[1];
        break;
      }
    }
    return cookieValue;
  },
  /**
   * cookie 删除
   * @param {*} cookieName
   */
  removeCookie(cookieName, path = "") {
    document.cookie =
      encodeURIComponent(cookieName) +
      "=; expires=" +
      new Date() +
      ";path=/" +
      encodeURIComponent(path);
  },
};
